import {
  getQuestionnaireDocumentNumberUrl,
  getQuestionnaireHasDeprecatedTemplatesUrl,
} from '~/src/entities/questionnaires/urls';

export const getQuestionnaireDocumentNumbers = async (orgFprint: string) => {
  const res = await fetch(getQuestionnaireDocumentNumberUrl(orgFprint));
  const jsonData = await res.json();
  return jsonData;
};

export const getQuestionnaireHasDeprecatedTemplates = async (
  orgFprint: string,
): Promise<Record<string, { title: string | null; subtitle: string }[]>> => {
  const res = await fetch(getQuestionnaireHasDeprecatedTemplatesUrl(orgFprint));
  return res.json();
};
